import { useAuthStore } from '@/store/auth.store';
import { ROLE_CONFIG } from '@/types/auth.types';
import { I } from '@/icons';

const PAGE_TITLES: Record<string, string> = {
  intake: 'Intake queue',
  workspace: 'Document workspace',
  qc: 'QC checklist',
  proofread: 'Proofread',
  audit: 'Audit trail',
  rules: 'Rules & checklists',
};

interface TopbarProps {
  currentPage: string;
}

export function Topbar({ currentPage }: TopbarProps) {
  const user = useAuthStore((s) => s.user);
  const roleLabel = user ? ROLE_CONFIG[user.role].shortLabel : 'Guest';
  const pageTitle = PAGE_TITLES[currentPage] || currentPage;

  return (
    <div className="topbar">
      <div className="crumbs">
        <span>Klara</span>
        <I.chevron />
        <span>{roleLabel}</span>
        <I.chevron />
        <span className="current">{pageTitle}</span>
      </div>
    </div>
  );
}
